export default class ResponsibleDigitalInit {
    static init() {
        let progress = 0;

        const progressBar = () => {
            window.onwheel = event => {
                if (event.deltaY >= 0) {
                    const loaderBar = document.querySelector('#loader-bar');
                    if (! loaderBar) {
                        return;
                    }
                    const maxHeight = document.querySelector('.about-loader').clientHeight;
                    const position = loaderBar.getBoundingClientRect().top - window.innerHeight * 0.8;
                    const percent = position / maxHeight * -100;

                    if (percent > progress && percent <= 100) {
                        progress = percent;
                        loaderBar.style.height = `${percent}%`;
                    }

                    if (percent > 100 && allBlockAppeared()) {
                        loaderBar.style.height = `100%`;
                        window.removeEventListener('scroll', progressBar);
                    }
                    appearBlock();
                }
            }

        };

        const allBlockAppeared = () => {
            let hasAppeared = true;
            document.querySelectorAll('.about-content').forEach((element) => {
                if (! element.classList.contains('visible')) {
                    hasAppeared = false;
                }
            });
            return hasAppeared;
        };

        const appearBlock = () => {
            document.querySelectorAll('.about-content').forEach((element) => {
                const elementPosition = element.getBoundingClientRect();
                const canAppear = (elementPosition.top + elementPosition.height / 5 - window.innerHeight) < 0;
                if (canAppear && ! element.classList.contains('visible')) {
                    element.classList.add('visible');
                }
            });
        };

        window.addEventListener('scroll', progressBar);
    }
}
